import { TriangleAlert } from "lucide-react";
import { useParams } from "react-router";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useGoalTypes, usePortfolioCollection } from "@/lib/hooks/use-portfolio-collections";
import { useT } from "@/lib/i18n/use-t";

import { TableCardSkeleton } from "../skeleton-loaders";
import { GoalTypesTable } from "./goal-types-table";
import { T } from "./page.i18n";

export default function GoalTypesPage() {
  const { id } = useParams<{ id: string }>();
  const { goalTypes, isLoading } = useGoalTypes(id!);
  const { collection } = usePortfolioCollection(id!);
  const t = useT(T);

  if (isLoading) {
    return <TableCardSkeleton columns={5} />;
  }

  const starved = collection?.goalTypeStatus?.clientTypesWithoutGoalTypes ?? [];
  const clientTypeLabel = (type: string) =>
    type === "Person"
      ? t.clientTypePerson
      : type === "Company"
        ? t.clientTypeCompany
        : t.clientTypeGroup;

  return (
    <div className="space-y-4">
      {starved.length > 0 && (
        <Alert variant="warning">
          <AlertDescription className="flex items-center gap-2">
            <TriangleAlert className="h-4 w-4 shrink-0 text-warning" />
            {t.unreachableWarning(starved.map(clientTypeLabel).join(", "))}
          </AlertDescription>
        </Alert>
      )}
      <GoalTypesTable
        portfolioCollectionId={id!}
        goalTypes={goalTypes}
        mandatesEnabled={collection?.mandatesEnabled ?? false}
      />
    </div>
  );
}
